import { Global } from '@emotion/react';
import { useCallback, useEffect, useState } from 'react';

import { ChatScreen, WelcomeScreen } from '@app/ahava/modules';
import { isEmbeddedOpenChatAtom, useAtom } from '@/store';

import { AppContainer } from './App.container';
import { AppContent, AppWrapper, FooterText, globalStyles } from './App.styles';


export const App = () => {
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isChatOpen, setIsChatOpen] = useAtom(isEmbeddedOpenChatAtom);

  const [message, setMessage] = useState('');

  const sendMessage = useCallback((input: string) => {
    setMessage(input);
    setIsChatOpen(true)
    },
    [setIsChatOpen]
  );

  const onMessageReady = useCallback(() => setIsDisabled(false), []);

  const onSend = useCallback(() => setMessage(''), [])

  const onReset = useCallback(() => {
    setIsDisabled(true);
    setIsChatOpen(false)
  }, [setIsChatOpen])


  useEffect(() => {
    const loadBackgroundImages = () => {
      const allElements = document.querySelectorAll('*');
      const promises: Promise<void>[] = [];

      allElements.forEach(el => {
        const bg = window.getComputedStyle(el).backgroundImage;
        if (bg && bg !== 'none') {
          const urls = bg.match(/url\(['"]?([^'"]+)['"]?\)/g);
          if (urls) {
            urls.forEach(url => {
              const src = url.match(/url\(['"]?([^'"]+)['"]?\)/)?.[1];
              if (src) {
                promises.push(
                  new Promise<void>(resolve => {
                    const img = new Image();
                    img.src = src;
                    img.onload = img.onerror = () => resolve();
                  })
                );
              }
            });
          }
        }
      });

      return promises;
    };

    const bgPromises = loadBackgroundImages();

    Promise.all([...bgPromises, document.fonts.ready]).then(() => {
        document.getElementById('saywhatt-loader')?.remove();
    });
  }, []);

  return (
    <AppContainer>
      <Global styles={globalStyles(import.meta.env.DEV)}/>
      <AppWrapper isChatOpen={isChatOpen}>
        <AppContent>
          <WelcomeScreen
            isDisabled={isDisabled}
            visible={!isChatOpen}
            sendMessage={sendMessage}
          />
          <ChatScreen
            visible={isChatOpen}
            message={message}
            onSend={onSend}
            onReset={onReset}
            onMessageReady={onMessageReady}
          />
        </AppContent>
        <FooterText>Explore the Full Collection at <a href="https://www.ahava.com/">ahava.com</a></FooterText>
      </AppWrapper>
    </AppContainer>
  )
}